const PATH_PREFIX = '/account';

export default [
  {
    name: 'account.sign_in',
    path: `${PATH_PREFIX}/sign-in`,
  },
  {
    name: 'account.sign_up',
    path: `${PATH_PREFIX}/sign-up`,
  },
  {
    name: 'account.forgot',
    path: `${PATH_PREFIX}/forgot`,
  },
  {
    name: 'account.reset',
    path: `${PATH_PREFIX}/reset/:token`,
  },
];
